export default "__VITE_ASSET__BtRODiJO__"